export const popularRegions = [
  { label: '北京', value: 'beijing' },
  { label: '广东省', value: 'guangdong' },
  { label: '上海', value: 'shanghai' },
  { label: '河北省', value: 'hebei' },
  { label: '湖北省', value: 'hubei' }
]

export const regionCategories = [
  {
    name: '不限',
    regions: [{ label: '全国', value: 'nationwide' }]
  },
  {
    name: '华北',
    regions: [
      { label: '北京', value: 'beijing' },
      { label: '天津', value: 'tianjin' },
      { label: '河北省', value: 'hebei' },
      { label: '山西省', value: 'shanxi' },
      { label: '内蒙古', value: 'inner_mongolia' }
    ]
  },
  {
    name: '东北',
    regions: [
      { label: '辽宁省', value: 'liaoning' },
      { label: '吉林省', value: 'jilin' },
      { label: '黑龙江省', value: 'heilongjiang' }
    ]
  },
  {
    name: '华东',
    regions: [
      { label: '上海', value: 'shanghai' },
      { label: '江苏省', value: 'jiangsu' },
      { label: '浙江省', value: 'zhejiang' },
      { label: '安徽省', value: 'anhui' },
      { label: '福建省', value: 'fujian' },
      { label: '江西省', value: 'jiangxi' },
      { label: '山东省', value: 'shandong' }
    ]
  },
  {
    name: '华中',
    regions: [
      { label: '湖北省', value: 'hubei' },
      { label: '湖南省', value: 'hunan' },
      { label: '河南省', value: 'henan' }
    ]
  },
  {
    name: '华南',
    regions: [
      { label: '广东省', value: 'guangdong' },
      { label: '广西', value: 'guangxi' },
      { label: '海南省', value: 'hainan' }
    ]
  },
  {
    name: '西南',
    regions: [
      { label: '重庆', value: 'chongqing' },
      { label: '四川省', value: 'sichuan' },
      { label: '贵州省', value: 'guizhou' },
      { label: '云南省', value: 'yunnan' },
      { label: '西藏', value: 'tibet' }
    ]
  },
  {
    name: '西北',
    regions: [
      { label: '陕西省', value: 'shaanxi' },
      { label: '甘肃省', value: 'gansu' },
      { label: '青海省', value: 'qinghai' },
      { label: '宁夏', value: 'ningxia' },
      { label: '新疆', value: 'xinjiang' }
    ]
  },
  {
    name: '其他',
    regions: [
      { label: '香港特别行政区', value: 'hong_kong' },
      { label: '澳门特别行政区', value: 'macao' },
      { label: '台湾省', value: 'taiwan' }
    ]
  },
  {
    name: '海外',
    regions: [
      { label: '亚洲', value: 'asia' },
      { label: '欧洲', value: 'europe' },
      { label: '美洲', value: 'americas' },
      { label: '非洲', value: 'africa' },
      { label: '澳洲', value: 'oceania' }
    ]
  }
]
